export default __webpack_public_path__ + "static/media/plus_alt.b46a52ee.svg";